"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigationArrowFontSize = void 0;
/**
 * Decides `font-size` of navigation icon based on `navigation.size`.
 *
 * @param param0 object containing `size` attribute from `navigation`.
 * @returns `font-size` of navigation icon.
 */
const getNavigationArrowFontSize = ({
  size
}) => size === 'small' ? '2.4rem' : '3.5rem';
exports.getNavigationArrowFontSize = getNavigationArrowFontSize;
//# sourceMappingURL=getNavigationArrowFontSize.js.map